import * as React from 'react';
import {connect} from "react-redux";
import {ApplicationState} from "../../store";
import {ColumnData} from '../../models/ColumnData';
import {Service} from '../../models/Service';
import {ServiceList} from '../components/ServiceList';
import {Tab, TabTypes} from '../Tab';
import {TabsService} from '../TabsService';
import {actionServiceFetchAll, actionDeleteService, actionDeleteServices} from '../../store/services/actions'
import AddIcon from "@material-ui/icons/AddCircleOutlineRounded";
import {Button} from "@material-ui/core";
import {Category} from "../../models/Category";
import {t} from "../../core/localization";

export interface ServicesTabProps {
	services: Service[],
	tab: Tab
}

export interface ServicesTabState {
}

function mapStateToProps(state: ApplicationState) {
	return {
		services: state.services.list,
		tab: state.tabs.active
	};
}

class ServicesTab extends React.Component<ServicesTabProps, ServicesTabState> {

	constructor(props: ServicesTabProps) {
		super(props)
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps: ServicesTabProps) {
	}

	componentDidMount() {
		actionServiceFetchAll();
	}

	onOpenClick(service: Service){
		TabsService.createTab(t.Service + ': ' + service.title, TabTypes.SERVICES_NEW, service)
	}

	onCopyClick(service: Service){
		TabsService.createTab(t.Service + ': ' + service.title, TabTypes.SERVICES_NEW, { ...service, id: null })
	}

	onDeleteClick(service: Service){
		actionDeleteService(service);
	}

	onActionDeleteClick(services: Service[]){
		actionDeleteServices(services);
	}

	render(): React.ReactNode {

		const {services} = this.props;

		const columns = [
			new ColumnData(t.Title, "title"),
			new ColumnData(t.Description, "description"),
		];

		return (
			<div style={{padding: '10px'}}>
				<div style={{marginBottom: '10px'}}><Button onClick={this.onNewClick} color="primary" style={{}}><AddIcon />{t.CreateNewService}</Button></div>
				<ServiceList
					columns={columns}
					items={services}
					title={t.Services}
					onOpenClick={(service: Service) => this.onOpenClick(service)}
					onCopyClick={(service: Service) => this.onCopyClick(service)}
					onDeleteClick={(service: Service) => this.onDeleteClick(service)}
					onActionDeleteClick={(services: Service[]) => this.onActionDeleteClick(services)}
					tab={this.props.tab}
				/>
			</div>
		);
	}

	onNewClick() {
		TabsService.createTab(t.NewService, TabTypes.SERVICES_NEW, new Service())
	}
}

export default connect(mapStateToProps)(ServicesTab);
